// eslint-disable-next-line no-useless-escape
export default address => RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(address);
